import InputField from '../../../components/atoms/InputField'
import Phone from '../../../assets/icons/phone.svg'
import RightArrow from '../../../assets/icons/right_arrow.svg'
import Checkbox from '../../../components/atoms/Checkbox'
import Button from '../../../components/atoms/GoodFlipButton'
import Text from '../../../components/atoms/Text'

const PhoneInputView = ({
  phoneNumber,
  setPhoneNumber,
  tnc,
  setTnc,
  onPressSubmit,
  buttonTitle,
  sheetHeader,
  loading = false,
}) => {
  return (
    <>
      <div className="w-full flex flex-col gap-4 p-4">
        <Text
          tag="p"
          variant="title"
          size="small"
          className="text-text-primary"
        >
          {sheetHeader}
        </Text>
        <InputField
          label="Mobile Number"
          type="tel"
          maxLength={10}
          leftIcon={<img src={Phone} alt="ph" className="h-6 w-6" />}
          prefix="+91"
          placeholder="Enter your mobile number"
          value={phoneNumber}
          autoFocus
          onChange={(event) => {
            if (/^\d{0,10}$/.test(event.target.value)) {
              setPhoneNumber(event.target.value)
            }
          }}
        />
        <div className="flex gap-2 items-start">
          <Checkbox initialState={tnc} onClick={(state) => setTnc(state)} />
          <Text
            tag="p"
            variant="label"
            size="medium"
            className="text-text-secondary"
          >
            I agree to receive important information about Chronic Kidney
            Disease. We don&apos;t spam!
          </Text>
        </div>
      </div>
      <Button
        title={buttonTitle}
        disabled={phoneNumber?.length < 10 || loading}
        type="goodflip_primary"
        className="mb-4"
        leftIcon={null}
        rightIcon={<img src={RightArrow} />}
        onClick={onPressSubmit}
        loading={loading}
      />
    </>
  )
}

export default PhoneInputView
